import { PlanTabsEnum } from 'constants/index';

export type State = {
  priceId: string;
  tab: PlanTabsEnum;
  open: boolean;
};

export const initialState: State = {
  priceId: '',
  tab: PlanTabsEnum.PLANS,
  open: false,
};

export enum ActionType {
  SET_PRICE_ID = 'setPriceId',
  SET_TAB = 'setTab',
  SET_OPEN = 'setOpen',
  RESET = 'reset',
}

export type Action =
  | { type: ActionType.SET_PRICE_ID; priceId: State['priceId'] }
  | { type: ActionType.SET_TAB; tab: State['tab'] }
  | { type: ActionType.SET_OPEN; open: State['open'] }
  | { type: ActionType.RESET };

export const staffReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PRICE_ID:
      return {
        ...state,
        priceId: action.priceId,
      };

    case ActionType.SET_TAB:
      return {
        ...state,
        tab: action.tab,
      };

    case ActionType.SET_OPEN:
      return {
        ...state,
        open: action.open,
      };

    case ActionType.RESET:
      return initialState;
  }
};
